import { mappingFunctionDef } from '../initialState';
import { IFunction } from '../properties.interface';

type TLookup = {
  mappingOverlapIdTypeId?: number;
  overlapIdFunction: IFunction;
  lookupColumnName: string | null;
  dataSourceId: number | null;
  lookupTableName: string | null;
};

type TOverlapDefaultValues = {
  mappingOverlapIdTypeId?: number | null;
  overlapIdFunction?: IFunction;
  overlapColumnName?: string | null;
  overlapDatasourceId?: number | null;
  overlapTableName?: string | null;
};

/**
 * getLookupDefaultValuesForNewMappings - sets defaults to be used by the selectedMapping redux state variable, (in the Lookups form) for new mappings
 * @param {array} lookups
 * @returns object
 */
export const getLookupDefaultValuesForNewMappings = (
  lookups: TLookup[] = []
): { overlapDefaultValues: TOverlapDefaultValues; overlapChecked: boolean } => {
  let overlapChecked = lookups.length > 0;
  let overlapDefaultValues = {};

  if (lookups.length > 0) {
    overlapDefaultValues = {
      mappingOverlapIdTypeId: lookups[0].hasOwnProperty('mappingOverlapIdTypeId')
        ? lookups[0]?.mappingOverlapIdTypeId
        : null,
      overlapIdFunction: lookups[0].overlapIdFunction || mappingFunctionDef,
      overlapColumnName: lookups[0].lookupColumnName || null,
      overlapDatasourceId: lookups[0].dataSourceId || null,
      overlapTableName: lookups[0].lookupTableName || null,
    };
  }

  return {
    overlapDefaultValues,
    overlapChecked,
  };
};
